import AddIcon from '@mui/icons-material/Add'
import {
  Grid,
  Button,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Stack,
  Typography,
} from '@mui/material'
import { IconSearch, IconFilter } from '@tabler/icons-react'
import { ProductStatusFilter } from '../../types'
import { channels } from '../../../../constants'

interface EnhancedTableToolbarProps {
  totalCount: number
  searchQuery: string
  onSearchChange: (value: string) => void
  supplierFilter: string
  onSupplierChange: (value: string) => void
  statusFilter: ProductStatusFilter
  onStatusChange: (value: ProductStatusFilter) => void
  onAddProduct: () => void
}

const EnhancedTableToolbar = ({
  totalCount,
  searchQuery,
  onSearchChange,
  supplierFilter,
  onSupplierChange,
  statusFilter,
  onStatusChange,
  onAddProduct,
}: EnhancedTableToolbarProps) => {
  const handleSupplierChange = (event: SelectChangeEvent) => {
    onSupplierChange(event.target.value)
  }

  const handleStatusChange = (event: SelectChangeEvent) => {
    onStatusChange(event.target.value as ProductStatusFilter)
  }

  return (
    <Stack spacing={1}>
      <Button
        variant="contained"
        startIcon={
          <AddIcon
            sx={{
              position: 'relative',
              bottom: 1.5,
              left: 2,
            }}
          />
        }
        onClick={onAddProduct}
        sx={{
          alignSelf: 'flex-end',
        }}
      >
        New Product
      </Button>

      <Typography variant="subtitle2" color="text.secondary">
        {totalCount} of {totalCount} Products
      </Typography>
      <Grid container justifyContent="space-between">
        <Grid item xs={4} md={8.75}>
          <TextField
            placeholder="Search products..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IconSearch size={18} />
                </InputAdornment>
              ),
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={4} md={1.5}>
          <FormControl size="small" fullWidth>
            <Select
              value={supplierFilter}
              onChange={handleSupplierChange}
              displayEmpty
              startAdornment={
                <InputAdornment position="start">
                  <IconFilter size={16} />
                </InputAdornment>
              }
            >
              <MenuItem value="all">All Suppliers</MenuItem>
              {channels.map((channel) => (
                <MenuItem key={channel.value} value={channel.value}>
                  {channel.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4} md={1.5}>
          <FormControl size="small" fullWidth>
            <Select value={statusFilter} onChange={handleStatusChange} displayEmpty>
              <MenuItem value="all">All Status</MenuItem>
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Stack>
  )
}

export default EnhancedTableToolbar
